import type { DiagnosticsNotice } from '../diagnostics';
import type { Recording, SessionPlan } from '../types';

interface Props {
  recording: Recording;
  plan: SessionPlan;
  diagnosticsStatus: DiagnosticsNotice | null;
  onDone: () => void;
}

const DIAGNOSTICS_COPY: Record<DiagnosticsNotice, string> = {
  sending: 'Sending diagnostics…',
  sent: 'Diagnostics sent.',
  failed: 'Diagnostics failed to send. They will retry next time.',
  skipped: 'Diagnostics upload skipped.',
};

export function Done({ recording, plan, diagnosticsStatus, onDone }: Props) {
  return (
    <div class="screen">
      <div class="shell stack" style={{ flex: 1, justifyContent: 'center' }}>
        <h1 class="serif">
          {new Date(recording.recordedOn).toLocaleDateString('en-GB',
            { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
        </h1>
        <p class="dim">
          That was {recording.title}, recorded at the Dhammaloka Buddhist Centre in Perth.
          {' '}You sat for {Math.round(plan.actualSec / 60)} minutes.
        </p>
        {diagnosticsStatus && (
          <p class="dim" role="status" data-testid="sit-diagnostics-status"
             style={{ fontSize: 'var(--step--2)', margin: 0 }}>
            {DIAGNOSTICS_COPY[diagnosticsStatus]}
          </p>
        )}
        <button class="btn btn-primary" onClick={onDone}>Done</button>
      </div>
    </div>
  );
}
